export const CAPSULE_NAME_SUFFIX = '’s Capsule';

export const getEditablePartByName = (capsuleName: string) => {
    const regex = new RegExp(CAPSULE_NAME_SUFFIX + '$');
    return capsuleName.replace(regex, '');
}

export const getFullCapsuleName = (editablePart?: string) => {
  return `${editablePart ?? ''}${CAPSULE_NAME_SUFFIX}`
}
